'use strict';

/**
 * Get value of a nested property
 *
 * @param mainObject
 * @param key
 * @returns {*}
 */

module.exports = function nestedValue(mainObject, key) {
  try {
    return key.split('.').reduce(function (obj, property) {
      return obj[property];
    }, mainObject);
  } catch (err) {
    // If we end up here, we're not working with an object, and @var mainObject is the value itself
    return mainObject;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/helpers/nestedValue.js
// module id = DFRx
// module chunks = 0